const phrases = [
  'Automate the update. Escalate the exception.',
  'Make the human touch more effective.',
  'One vehicle. One history. One source of truth.',
  'Digital when it should be. Human when it needs to be.',
];

export const ManifestoMarquee = () => (
  <div className="overflow-hidden border-y border-[#E5E7EB] bg-[#F4F5F1] py-4" aria-hidden="true">
    <div className="animate-relay-marquee flex w-max items-center whitespace-nowrap">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center">
          {phrases.map((p) => (
            <span key={`${copy}-${p}`} className="flex items-center">
              <span className="font-op px-8 text-xs font-medium uppercase tracking-[0.24em] text-[#0F5C4A]">
                {p}
              </span>
              <span className="h-1 w-1 rounded-full bg-[#2563EB]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
